import React from "react";
import ReactDOM from "react-dom";
import App from "./App";

import "react-responsive-modal/styles.css";

ReactDOM.render(<App />, document.querySelector("#root"));
